<template>
  <span class="mr-2">{{ formattedDisplayNumber }}</span>
</template>

<script>
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'AnimatedNumber',
  props: {
    number: { default: 0 },
  },
  data() {
    return {
      displayNumber: 0,
      interval: false,
    }
  },
  mounted() {
    this.displayNumber = this.number ? this.number : 0
  },
  computed: {
    formattedDisplayNumber() {
      return new Intl.NumberFormat('en-US').format(this.displayNumber)
    },
  },
  watch: {
    number() {
      clearInterval(this.interval)

      if (this.number == this.displayNumber) {
        return
      }

      this.interval = window.setInterval(() => {
        if (Math.abs(this.number - this.displayNumber) <= 1) {
          this.displayNumber = this.number
          clearInterval(this.interval)
          return
        }

        let change = (this.number - this.displayNumber) / 10
        change = change >= 0 ? Math.ceil(change) : Math.floor(change)
        this.displayNumber = this.displayNumber + change
      }, 20)
    },
  },
}
</script>
